export function contains(value, searchTerm, ignoreCase = true) {
    if (ignoreCase) {
        value = value.toLowerCase();
        searchTerm = searchTerm.toLowerCase();
    }

    return value.includes(searchTerm);
}
